import Vue from 'vue'
import to from 'await-to-js'
import client from '@/api/client'
import HOMEPAGE_QUERY from '@/api/gql/homepage/query/homepage.gql'

const DEFAULT_TEMPLATE = 'C'

const getCategorySliderData = vm => {
  // TODO: #3581 ⁃ Provide category slider data via GraphQl
  // TODO: #3407 ⁃ Add final hard-coded data for category slider
  const getFullUrl = vm.$store.getters['page/getFullUrl']
  const ctaText = vm.$t('discover_cta')
  const CATEGORY_SLIDER_DATA = [
    {
      title: vm.$t('waterproof_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/2aWkcKDk3znwIzeqQrS87d/7e287abc9efeae0d1587bbc6c154cafe/CategorySlider_Waterproof.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/waterproof') }],
    },
    {
      title: vm.$t('cloud_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/6gZcPgd17cXqtbzJu0Evxl/5c070655dea9900636fba666ccbe3c6c/CategorySlider_Cloud.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/cloud') }],
    },
    {
      title: vm.$t('the_roger_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/17Bc9kPqpjd7WrS36cX0EW/5e58592be97cae10168b05edb74d9796/CategorySlider_TheRoger.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/roger') }],
    },
    {
      title: vm.$t('apparel'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/5DyUr41so1xWFrWIDRfMft/8e45f16b92ae0e6150a26a7c2d5a0213/CategorySlider_Apparel.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/apparel') }],
    },
    {
      title: vm.$t('gift_ideas'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/VpCjgpP852C72dzF4iR0q/3e5e4c239de2ae4d9ceabf4f83c97504/CategorySlider_GiftsIdeas.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/gift-ideas') }],
    },
    {
      title: vm.$t('latest'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/3PEJupJcbrTozMzdWKfaFB/205647258ef9a7ae328724043de64a24/CategorySlider_NewArrivals.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/?release_date=new-arrivals') }],
    },
    {
      title: vm.$t('home_workout'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/6QEaVFK1oJ62CCUXy3sBN8/f0af04792a5a58d1712b6424a832ad52/CategorySlider_HomeWorkouts.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/homeworkout') }],
    },
    {
      title: vm.$t('bestsellers'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/2GtRIsKnDpjIuShDCOnWNh/dae536400cdd2cadf1d482078a764800/CategorySlider_BestSellers.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/?sort=bestseller') }],
    },
    {
      title: vm.$t('cloudnova_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/42DDKWfZBhtM0PwDBv8dOM/5d36de535db4b18f40ffab1626903f9e/CategorySlider_Cloudnova.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/cloudnova') }],
    },
    {
      title: vm.$t('road_running'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/4Rbmi9NAID17nvgZfWaNCy/3abaddc443258ced8730f38df82efae5/CategorySlider_Running.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/shoes/road') }],
    },
    {
      title: vm.$t('outdoor_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/7BkE97baUDapv6136HexWR/5e7cb7a20c5ffbcad6ed3a3e63e9ba3c/CategorySlider_Outdoors.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/outdoor') }],
    },
    {
      title: vm.$t('shoe_finder'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/4mRASkbDi70xmhAq7U4JE2/fe330a4c176d6b1d15651aa63f0c036c/CategorySlider_ShoeFinder.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/shoe-finder') }],
    },
  ]

  return CATEGORY_SLIDER_DATA
}

const HomepageService = {
  async fetch(vm) {
    const [error, result] = await to(client.query({ query: HOMEPAGE_QUERY }))
    if (error) Vue.rollbar.error(error.message, error)
    const homepage = result?.data?.homepage || {}
    if (!homepage.template) homepage.template = DEFAULT_TEMPLATE
    return {
      ...homepage,
      categorySlider: getCategorySliderData(vm, homepage.template),
    }
  },
}

export default HomepageService
